module.exports = __webpack_public_path__ + "static/features-slide3-79d3072e6aafac95400f814bfe6b44a5.png";